import MainImage from '../voluntary-template/icons/VoluntaryContractual.png';
import VectorFirst from '../voluntary-template/icons/box/shield.svg';
import VectirSecond from '../voluntary-template/icons/box/clinical_notes.svg';
import VectorThird from '../voluntary-template/icons/box/portfolio.svg';
import Checkbox from '../voluntary-template/icons/Checkbox.svg';
import Thunder from '../voluntary-template/icons/Thunder.svg';
import Contract from '../voluntary-template/icons/GPO_dogovor.png';
import Shield from '../voluntary-template/icons/Shield.png';
import Star from '../voluntary-template/icons/Star.png';
import Pyramid from '../voluntary-template/icons/pyramid.png';
import People from '../voluntary-template/icons/people.png';
import Box from '../voluntary-template/icons/Box.png';

const voluntaryContractResources = {
  en: {
    voluntaryContract: {
      title: 'Contractual civil liability insurance',
      description:
        'Guaranteed protection of your obligations — we ensure your confidence every step of the way.',
      buttonText: 'Submit Application',
      infoCards: [
        {
          title: 'Suitable for tenders and procurement',
          content:
            'The policy meets the requirements of both governmental and commercial customers.',
        },
        {
          title: 'Personalized terms',
          content:
            'We tailor the offer based on the type of obligation, contract amount, and project specifics.',
        },
        {
          title: 'Enhanced trust',
          content:
            'Having insurance builds a positive business reputation for the company.',
        },
      ],
      coverage: [
        {
          title: 'What we insure',
          content: [
            'Contract performance obligations',
            'Utilization of advance payments',
            'Warranty obligations',
          ],
        },
        {
          title: 'Covered risks',
          content: [
            'Violation of contract terms',
            'Delayed or improper use of advance payments',
            'Failure to fulfill warranty obligations after project completion',
          ],
        },
        {
          title: 'Illustration',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Insurance amount',
          content: 'Set individually',
        },
        {
          title: 'Validity period',
          content: 'Entire duration of the contract or obligations',
        },
        {
          title: 'Coverage area',
          content: 'Republic of Kazakhstan',
        },
      ],
      formTitle: 'Insurance Application',
      formDescription:
        'Please be sure to provide the company name, BIN, and contact phone number.',
      formCheckBox1: 'I confirm',
      formCheckBox2:
        'my consent to the collection and processing of personal data',
      formPlaceholder1: 'Company',
      formPlaceholder2: 'BIN',
      formPlaceholder3: 'Full Name',
      formPlaceholder4: 'Phone',
      formPlaceholder5: 'Email',
      formPlaceholder6: 'Comment',
      formButtonText: 'Submit Application',
      formSuccessStatus: 'Your application has been submitted successfully.',
      formErrorStatus: 'Failed to submit the application.',
      formErrorMessage:
        'Please try submitting the application again in 4 hours.',
      formSendClose: 'Close',
      trustTitle: 'Why clients trust Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 years',
            content: 'on the insurance market of Kazakhstan',
          },
          {
            id: 2,
            title: 'TOP 2',
            content: 'by volume of insurance payouts',
          },
          {
            id: 3,
            title: 'kzA-',
            content: 'financial stability rating by S&P Global Ratings',
          },
          {
            id: 4,
            title: '600+',
            content: 'employees working across the country',
          },
        ],
        second: [
          {
            id: 5,
            title: '₸59.4 billion',
            content: 'insurance premiums collected in 2024',
          },
          {
            id: 6,
            title: '₸22 billion',
            content: 'insurance payouts made in 2024',
          },
        ],
        third: '(According to the National Bank of Kazakhstan, Jan–Feb 2025)',
      },
    },
  },
  kz: {
    voluntaryContract: {
      title:
        'Шарт бойынша азаматтық-құқықтық жауапкершілікті ерікті сақтандыру',
      description:
        'Келісімшарт бойынша қабылданған міндеттемелеріңізді орындау бөлігінде Сіздің жауапкершілігіңізді сақтандыру.',
      buttonText: 'Өтініш беру',
      infoCards: [
        {
          title: 'Сақтандыру не үшін қажет',
          content:
            'Тендерлер мен сатып алулар үшін мемлекеттік сатып алулар мен конкурстарға қатысу кезінде қамтамасыз ету түрі ретінде, сондай-ақ тапсырыс берушілердің келісімшарттар бойынша талаптарын орындау үшін қажетті.',
        },
        {
          title: 'Дербес талаптар',
          content:
            'Сақтандыру талаптары әрбір клиент бойынша дербес белгіленеді.',
        },
        {
          title: 'Сенімділікті арттыру',
          content:
            'Сақтандырудың болуы оң беделге ие болуға және бизнесті дамытуға мүмкіндік береді.',
        },
      ],
      coverage: [
        {
          title: 'Нені сақтандырамыз',
          content: [
            'Тапсырыс берушінің алдында келісімшарт бойынша қабылданған міндеттемелерді орындамау/тиісінше орындамау нәтижесінде келтірілген залалды өтеу бөлігінде туындайтын жауапкершілікті.',
            // 'Шартты орындау бойынша міндеттемелер',
            // 'Аванстық төлемдерді игеру',
            // 'Кепілдік міндеттемелер',
          ],
        },
        {
          title: 'Қандай тәуекелдерден',
          content: [
            'Келісімшарт бойынша талаптарды, сондай-ақ аванстық (алдын ала) төлемді игеруге байланысты немесе кепілдік міндеттемелерді орындауға байланысты талаптарды орындамау/тиісінше орындамау.',
            // 'Шартты орындау талаптарын бұзу',
            // 'Авансты мезгілінен кешіктіріп немесе мақсатсыз пайдалану',
            // 'Жұмыстарды тапсырғаннан кейін кепілдік міндеттемелерді орындамау',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Сақтандыру сомасы',
          content: 'Келісімшарт талаптарына сәйкес жеке белгіленеді.',
        },
        {
          title: 'Қолданыс мерзімі',
          content:
            'Сақтандыру шартының қолданылу мерзімі - келісімшарт бойынша, сондай-ақ тараптардың келісімі бойынша талаптарға сәйкес.',
        },
        {
          title: 'Сақтандыру аумағы',
          content: 'Қазақстан Республикасы.',
        },
      ],
      formTitle: 'Өтінім қалдыру',
      formDescription: 'БСН және байланыс телефонын көрсетуді ұмытпаңыз.',
      formCheckBox1: 'Мен',
      formCheckBox2:
        'жеке деректерімді жинауға және өңдеуге келісімімді растаймын',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БСН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.пошта',
      formPlaceholder6: 'Түсініктеме',
      formButtonText: 'Жөнелту',
      formSuccessStatus: 'Сіздің өтінішіңіз сәтті жіберілді.',
      formErrorStatus: 'Өтінішті жіберу сәтсіз аяқталды.',
      formErrorMessage: 'Өтінішті 4 сағаттан кейін жіберіп көріңіз.',
      formSendClose: 'Жабу',
      trustTitle: 'Неліктен клиенттер Alatau City Garant-қа сенім артады',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 жыл',
            content: 'Қазақстанның сақтандыру нарығында қызмет еткеніне',
          },
          {
            id: 2,
            title: '3 орын',
            content:
              '2024 жылы ҚР жалпы сақтандыру компаниялары арасында сақтандыру төлемдерінің көлемі бойынша',
          },
          {
            id: 3,
            title: 'ВВ-Болжам «Тұрақты»',
            content: 'S&P Global Ratings қаржылық тұрақтылық рейтингі',
          },
          {
            id: 4,
            title: '22 филиал',
            content: 'Alatau City Garant бүкіл ел аумағында жұмыс істейді',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content:
              'сақтандыру сыйлықақыларын Alatau City Garant 2024 жылы жинады',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'Alatau City Garant 2024 жылы клиенттерге төледі',
          },
        ],
        third: '(ҚР Ұлттық Банкінің деректері бойынша)',
      },
      businessDescription:
        'Міндеттемелеріңіздің кепілдендірілген қорғанысы — әр қадамыңызда сенімділікпен қамтамасыз етеміз.',
    },
  },
  ru: {
    voluntaryContract: {
      title: 'Страхование гражданско-правовой ответственности по договору',
      description:
        'Страхование вашей ответственности в части исполнения ваших обязательств, принятых по контракту.',
      buttonText: 'Отправить заявку',
      infoCards: [
        {
          title: 'Для чего нужна страховка',
          content:
            'Подходит для тендеров и закупок, как вид  обеспечения при участии в государственных закупках и в конкурсах, а также для исполнения требований Заказчиков по контрактам.',
        },
        {
          title: 'Персональные условия',
          content:
            'Условия страхования устанавливаются по каждому клиенту индивидуально.',
        },
        {
          title: 'Повышение доверия',
          content:
            'Наличие страховки дает возможность иметь положительную репутацию и развитие бизнеса.',
        },
      ],
      coverage: [
        {
          title: 'Что страхуем',
          content: [
            'Ответственность, возникающая в части возмещения ущерба перед Заказчиком, причиненный  в результате неисполнения/ненадлежащего исполнения  обязательств принятых по Контракту.',
            // 'Обязательства по исполнению договора',
            // 'Освоение авансовых платежей',
            // 'Гарантийные обязательства',
          ],
        },
        {
          title: 'От каких рисков',
          content: [
            'Неисполнения/ненадлежащего исполнения условий по Контракту, а также связанных с освоением авансового (предварительного) платежа или связанных с выполнением гарантийных обязательств.',
            // 'Нарушение условий исполнения договора',
            // 'Несвоевременное или нецелевое использование аванса',
            // 'Неисполнение гарантийных обязательств после сдачи работ',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Страховая сумма',
          content:
            'Устанавливается индивидуально, согласно требованиям по Контракту.',
        },
        {
          title: 'Срок действия',
          content:
            'Срок действия договора страхования согласно требованиям по Контракту, а также по соглашению сторон.',
        },
        {
          title: 'Территория страхования',
          content: 'Республика Казахстан.',
        },
      ],
      formTitle: 'Заявка на страхование',
      formDescription:
        'Пожалуйста, обязательно укажите БИН и контактный телефон.',
      formCheckBox1: 'Я подтверждаю ',
      formCheckBox2: 'согласие на сбор и обработку персональных данных',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БИН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.почта',
      formPlaceholder6: 'Комментарий',
      formButtonText: 'Отправить заявку',
      formSuccessStatus: 'Спасибо! Ваша заявка отправлена',
      formErrorStatus: 'Не удалось отправить заявку',
      formErrorMessage: 'Попробуйте отправить заявку через 4 часа.',
      formSendClose: 'Закрыть',
      trustTitle: 'Почему клиенты доверяют Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 лет',
            content: 'на страховом рынке Казахстана',
          },
          {
            id: 2,
            title: '3 место',
            content:
              'по объему страховых выплат среди компаний общего страхования РК в 2024 году',
          },
          {
            id: 3,
            title: 'ВВ-прогноз «Стабильный»',
            content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
          },
          {
            id: 4,
            title: '22 филиала',
            content: 'Alatau City Garant работают по всей стране ',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content: 'страховых премий собрал Alatau City Garant в 2024 году',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'выплатил Alatau City Garant клиентам в 2024 году ',
          },
        ],
        third: '(по данным Нацбанка РК)',
      },
      businessDescription:
        'Гарантированная защита ваших обязательств — мы обеспечим вашу уверенность в каждом шаге.',
    },
  },

  mainCard: {
    image: MainImage,
  },
  infoCards: [
    {
      id: 1,
      image: VectorFirst,
    },
    {
      id: 2,
      image: VectirSecond,
    },
    {
      id: 3,
      image: VectorThird,
    },
  ],
  coverage: [
    {
      title: 'Что страхуем',
      content: [
        'Ответственность, возникающая в части возмещения ущерба перед Заказчиком, причиненный  в результате неисполнения/ненадлежащего исполнения  обязательств принятых по Контракту ',
        // 'Обязательства по исполнению договора',
        // 'Освоение авансовых платежей',
        // 'Гарантийные обязательства',
      ],
      image: Checkbox,
    },
    {
      title: 'Покрываемые риски',
      content: [
        'Неисполнения/ненадлежащего исполнения условий по Контракту, а также связанных с освоением авансового (предварительного) платежа или связанных с выполнением гарантийных обязательств',
        // 'Нарушение условий исполнения договора',
        // 'Несвоевременное или нецелевое использование аванса',
        // 'Неисполнение гарантийных обязательств после сдачи работ',
      ],
      image: Thunder,
    },
    {
      title: 'Иллюстрация',
      content: [],
      image: Contract,
    },
  ],
  featureCards: [
    {
      title: 'Страховая сумма',
      content: 'Устанавливается индивидуально',
    },
    {
      title: 'Срок действия',
      content: 'Весь срок действия договора или обязательств',
    },
    {
      title: 'Территория действия',
      content: 'Республика Казахстан',
    },
  ],
  trustCards: {
    first: [
      {
        id: 1,
        title: '17 лет',
        content: 'на страховом рынке Казахстана',
        image: Shield,
      },
      {
        id: 2,
        title: 'ТОП 2',
        content: 'по объёму страховых выплат ',
        image: Star,
      },
      {
        id: 3,
        title: 'kzA-',
        content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
        image: Pyramid,
      },
      {
        id: 4,
        title: '600+',
        content: 'сотрудников работают по всей стране',
        image: People,
      },
    ],
    second: [
      {
        id: 5,
        title: '59,4 млрд ₸',
        content: 'страховых премий собрано за 2024 год ',
      },
      {
        id: 6,
        title: '22 млрд ₸',
        content: 'выплачено по страховым случаям за 2024 год',
      },
    ],
    image: Box,
  },
};

export default voluntaryContractResources;
